import { render, staticRenderFns } from "./NewCustomerPage.vue?vue&type=template&id=7a44d94e&"
import script from "./NewCustomerPage.vue?vue&type=script&lang=js&"
export * from "./NewCustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./NewCustomerPage.vue?vue&type=style&index=0&id=7a44d94e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports